import React from "react";

const ProcessStep = ({ step, text, isActive }) => {
  return (
    <div style={{ textAlign: "center", margin: "0 5px" }}>
      <div style={{
        width: 50,
        height: 50,
        borderRadius: "50%",
        backgroundColor: isActive ? "#3182F6" : "#e5e8ed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        fontSize: 18,
        fontWeight: 700,
        color: isActive ? "#fff" : "#9ca3af",
      }}>
        {step}
      </div>
      <div style={{ fontSize: 14, color: isActive ? "#3182F6" : "#9ca3af", marginTop: 6, fontWeight: isActive ? 600 : 400 }}>{text}</div>
    </div>
  );
};

export default ProcessStep;
